import { FC, default as React } from 'react';

import { SHeader } from './style';
//import ReactSpinePlayer from '../SpinePlayer/ReactSpinePlayer';

const Header: FC = ({ children }) => {
  return (
    <SHeader>
      {/*<ReactSpinePlayer />*/}
      {children}
    </SHeader>
  );
};

export default Header;
